import { zone } from '../constants';

/**
     * Import constants
     */
const {
  SET_ZONESTR,
  SET_ZONEARY,
  SET_PROMPTS,
  SET_COORDINATE,
  SET_FULL_ADDRESS,
  SET_COUNTRY_NAME,
  SET_MAP_CITY_NAME,
  SET_EXAMPLEADDRESS,
  SET_GOOGLESEARCHTERM,
} = zone;

/**
     * Action creators
     */
const actions = {
  setZoneStr: (data) => ({ type: SET_ZONESTR, data }),
  setZoneAry: (data) => ({ type: SET_ZONEARY, data }),
  setPrompts: (data) => ({ type: SET_PROMPTS, data }),
  setCoordinate: (data) => ({ type: SET_COORDINATE, data }),
  setCountryName: (data) => ({ type: SET_COUNTRY_NAME, data }),
  setFullAddress: (data) => ({ type: SET_FULL_ADDRESS, data }),
  setMapCityName: (data) => ({ type: SET_MAP_CITY_NAME, data }),
  setExampleAddress: (data) => ({ type: SET_EXAMPLEADDRESS, data }),
  setGoogleSearchTerm: (data) => ({ type: SET_GOOGLESEARCHTERM, data }),
};

export const setLat = (lat) => (dispatch) => dispatch(actions.setLat(lat));

export const setLong = (lng) => (dispatch) => dispatch(actions.setLong(lng));

export const setZoneStr = (zoneStr) => (dispatch) => dispatch(actions.setZoneStr(zoneStr));

export const setZoneAry = (zoneAry) => (dispatch) => dispatch(actions.setZoneAry(zoneAry));

export const setPrompts = (prompts) => (dispatch) => dispatch(actions.setPrompts(prompts));

export const setCoordinate = (coordinate) => (dispatch) => dispatch(
  actions.setCoordinate(coordinate)
);

export const setExampleAddress = (exampleAddress) => (dispatch) => dispatch(
  actions.setExampleAddress(exampleAddress)
);

export const setGoogleSearchTerm = (googleSearchTerm) => (dispatch) => dispatch(
  actions.setGoogleSearchTerm(googleSearchTerm)
);

export const setMapCityName = (mapCityName) => (dispatch) => dispatch(
  actions.setMapCityName(mapCityName)
);

export const setFullAddress = (fullAddress) => (dispatch) => dispatch(
  actions.setFullAddress(fullAddress)
);

export const setCountryName = (countryName) => (dispatch) => dispatch(
  actions.setCountryName(countryName)
);
